import { render, staticRenderFns } from "./EntranceStudy.vue?vue&type=template&id=ef6f15c4&scoped=true&lang=pug&"
import script from "./EntranceStudy.vue?vue&type=script&lang=ts&"
export * from "./EntranceStudy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6f15c4",
  null
  
)

export default component.exports